var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpNewLogoReversed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 538.92 93.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5071bf;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #6795ff;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67361",
    "data-name": "Group 67361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23571",
    "data-name": "Path 23571",
    className: "cls-1",
    d: "m47.28,0c-1.12,0-2.22.29-3.2.84L4.35,23.74c-3.87,2.21-5.23,7.14-3.04,11.02h0c2.22,3.44,6.53,4.87,10.36,3.44.27-.12.53-.2.86-.33h.06c.19-.1.36-.21.53-.33l31.41-19c1.59-.92,3.55-.92,5.14,0l31.48,19.07c4.06,2.4,9.29,1.14,11.82-2.84,2.24-3.87.92-8.83-2.95-11.07,0,0-.02-.01-.03-.02L50.47.84C49.5.29,48.4,0,47.28,0m.22,30.47c-2.03,0-4.02.58-5.73,1.67h0l-28.64,17.29c-.13.13-.33.19-.53.39h-.06l-6.31,3.82C2.36,55.98,0,60.17,0,64.69v21.42c0,4.29,3.47,7.78,7.76,7.79,1.38,0,2.73-.36,3.92-1.05l31.88-18.35c2.29-1.32,5.1-1.32,7.39,0l31.67,18.28c3.73,2.17,8.51.91,10.68-2.81.69-1.19,1.06-2.54,1.06-3.92v-21.29c0-4.52-2.36-8.71-6.23-11.06l-6.97-4.21-28.05-16.96c-1.62-1.25-3.58-1.97-5.62-2.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23572",
    "data-name": "Path 23572",
    className: "cls-2",
    d: "m42.91,68.54c2.64-1.5,5.87-1.5,8.51,0l36.98,21.04c1.91,1.09,4.35.42,5.44-1.49.34-.6.52-1.28.52-1.98v-22.62c0-3.69-1.93-7.1-5.08-9.01l-37.44-22.66c-2.87-1.74-6.46-1.74-9.33,0L5.08,54.48C1.93,56.39,0,59.81,0,63.49v22.62c0,2.2,1.79,3.99,3.99,3.99.69,0,1.37-.18,1.97-.52l36.95-21.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23573",
    "data-name": "Path 23573",
    className: "cls-2",
    d: "m87.8,35.24c-1.1,0-2.19-.3-3.13-.86L48.24,12.72c-.39-.24-.83-.39-1.29-.43-.44.03-.87.17-1.25.4L9.43,34.17c-2.92,1.73-6.69.76-8.42-2.16-1.73-2.92-.76-6.69,2.16-8.42h0L39.39,2.16C41.56.85,44.03.11,46.56.01h0C46.65,0,46.74,0,46.84,0h.5c2.55.12,5.04.87,7.22,2.19l36.39,21.63c2.92,1.73,3.88,5.5,2.14,8.42-1.11,1.86-3.12,3.01-5.29,3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23599",
    "data-name": "Path 23599",
    className: "cls-3",
    d: "m145.65,48.12c-1.27-.7-2.61-1.25-4.01-1.64-1.47-.42-2.92-.8-4.37-1.13-1.35-.31-2.68-.69-3.98-1.14-1.09-.35-2.09-.93-2.94-1.69-.77-.74-1.18-1.78-1.13-2.85,0-.97.29-1.91.84-2.7.68-.89,1.62-1.57,2.68-1.93,1.5-.53,3.09-.77,4.68-.72,1.58,0,3.16.23,4.68.65,1.63.45,3.18,1.15,4.59,2.1l1.59-3.86c-1.54-1.02-3.23-1.77-5.02-2.22-1.9-.51-3.87-.77-5.84-.77-2.5-.09-5,.37-7.31,1.33-1.73.73-3.21,1.95-4.25,3.52-.91,1.44-1.39,3.1-1.38,4.8-.07,1.55.32,3.08,1.11,4.42.73,1.14,1.74,2.07,2.92,2.73,1.27.7,2.61,1.26,4.01,1.66,1.47.44,2.92.81,4.37,1.13,1.35.29,2.68.67,3.98,1.13,1.09.36,2.09.95,2.94,1.71.76.73,1.18,1.75,1.13,2.8.01.96-.29,1.9-.87,2.68-.7.87-1.64,1.52-2.7,1.86-1.54.5-3.16.73-4.78.68-2.13,0-4.24-.37-6.23-1.11-1.8-.63-3.47-1.58-4.92-2.8l-1.79,3.77c1.61,1.4,3.5,2.45,5.55,3.06,2.38.79,4.88,1.19,7.39,1.18,2.52.08,5.03-.37,7.36-1.33,1.75-.73,3.26-1.95,4.32-3.52.92-1.41,1.41-3.07,1.4-4.75.06-1.53-.32-3.04-1.11-4.35-.74-1.12-1.74-2.05-2.92-2.7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3852",
    "data-name": "Rectangle 3852",
    className: "cls-3",
    x: 166.86,
    y: 30.6,
    width: 4.83,
    height: 33.79
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23600",
    "data-name": "Path 23600",
    className: "cls-3",
    d: "m196.79,30.6h-4.83v33.79h23.12v-4.2h-18.29v-29.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23601",
    "data-name": "Path 23601",
    className: "cls-3",
    d: "m234.63,49.28h16.94v-4.1h-16.94v-10.38h19.02v-4.2h-23.85v33.79h24.52v-4.2h-19.69v-10.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23602",
    "data-name": "Path 23602",
    className: "cls-3",
    d: "m296.52,55.77l-20.27-25.18h-3.96v33.79h4.83v-25.18l20.27,25.18h3.96V30.6h-4.83v25.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23603",
    "data-name": "Path 23603",
    className: "cls-3",
    d: "m316.74,34.8h11.59v29.59h4.78v-29.59h11.59v-4.2h-27.95v4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23604",
    "data-name": "Path 23604",
    className: "cls-3",
    d: "m396.43,32.07c-2.47-1.04-5.14-1.54-7.82-1.47h-14.62v33.79h7.86v-9.31h6.76c2.68.07,5.35-.44,7.82-1.5,4.32-1.79,7.05-6.09,6.85-10.76.06-2.3-.56-4.57-1.78-6.52-1.24-1.87-3-3.34-5.07-4.22m-2.85,15.09c-1.56,1.14-3.48,1.68-5.41,1.54h-6.32v-11.73h6.32c1.92-.14,3.84.4,5.41,1.52,1.25,1.08,1.93,2.67,1.83,4.32.09,1.65-.59,3.26-1.83,4.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23605",
    "data-name": "Path 23605",
    className: "cls-3",
    d: "m441.42,49.28c0,3.19-.66,5.49-1.98,6.93-3.13,2.86-7.93,2.86-11.05,0-1.32-1.43-1.98-3.74-1.98-6.93v-18.68h-7.87v18.87c0,4.99,1.35,8.82,4.05,11.49,2.7,2.67,6.45,4,11.25,4,4.76,0,8.5-1.33,11.2-4,2.7-2.67,4.06-6.5,4.05-11.49v-18.87h-7.68v18.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23606",
    "data-name": "Path 23606",
    className: "cls-3",
    d: "m488.53,47.32c-1.2-.71-2.48-1.29-3.81-1.71-1.38-.45-2.78-.83-4.2-1.13-1.42-.31-2.7-.61-3.86-.92-1.01-.24-1.96-.67-2.8-1.28-.69-.5-1.09-1.32-1.06-2.17,0-.7.23-1.38.65-1.93.54-.65,1.25-1.13,2.05-1.38,1.2-.38,2.46-.55,3.71-.51,1.57.01,3.12.23,4.63.65,1.64.45,3.21,1.1,4.68,1.95l2.46-5.89c-1.68-1.02-3.52-1.77-5.43-2.22-2.06-.51-4.18-.77-6.3-.77-2.72-.09-5.42.4-7.94,1.42-1.91.79-3.54,2.11-4.71,3.81-1.02,1.57-1.56,3.41-1.54,5.28-.06,1.54.3,3.06,1.04,4.42.68,1.17,1.65,2.14,2.8,2.85,1.21.74,2.51,1.33,3.86,1.74,1.4.43,2.79.8,4.17,1.11s2.66.63,3.84.97c1.01.26,1.97.7,2.82,1.3.69.49,1.09,1.3,1.06,2.15.01.68-.23,1.35-.67,1.87-.57.61-1.3,1.05-2.1,1.28-1.21.36-2.48.52-3.74.48-2.05,0-4.09-.34-6.04-.99-1.83-.57-3.55-1.43-5.12-2.53l-2.65,5.89c1.81,1.3,3.85,2.26,6.01,2.82,2.54.73,5.16,1.09,7.8,1.08,2.73.09,5.44-.41,7.96-1.45,1.91-.79,3.56-2.12,4.75-3.81,1.04-1.54,1.58-3.36,1.57-5.21.14-2.93-1.37-5.7-3.91-7.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23607",
    "data-name": "Path 23607",
    className: "cls-3",
    d: "m531.1,30.6v13.32h-15.3v-13.32h-7.87v33.79h7.87v-13.85h15.3v13.85h7.82V30.6h-7.82Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpNewLogoReversed);
export default __webpack_public_path__ + "static/media/sp_new_logo_reversed.1139b0b59922d782f48af2802f316557.svg";
export { ForwardRef as ReactComponent };